export var addGetVersionToWindow = function (mainObjectName, sdkObjectName, getVersionImpl) {
    var _a;
    var mainObject = window[mainObjectName];
    if (typeof mainObject !== "object" ||
        typeof mainObject[sdkObjectName] !== "object" ||
        typeof mainObject[sdkObjectName].getVersion !== "function") {
        window[mainObjectName] = (_a = {},
            _a[sdkObjectName] = {
                getVersion: getVersionImpl,
            },
            _a);
    }
};
/**
 * Legacy arbitrary value stringification and truncation used by existing wallet SDKs.
 * New integrations must use the safe additional-info serializer instead.
 */
export var getAdditionalInfo = function (additionalInfo) {
    if (!additionalInfo) {
        return null;
    }
    var additionalInfoMaxLength = 255;
    var additionalInfoString = additionalInfo.toString();
    if (additionalInfoString === "[object Object]") {
        return JSON.stringify(additionalInfo).substring(0, additionalInfoMaxLength);
    }
    return additionalInfoString.substring(0, additionalInfoMaxLength);
};
